import { DashboardSummeryDetailsViewModel, DashboardSummerySubDetailsViewModel } from "@payping/api";
import { getSummary } from "@payping/redux/actions";
import { toJalali } from "@payping/utils/dateUtils";
import { Card, Chart } from "@payping/web-components";
import { AppLineType } from "@payping/web-components/components/Chart/types";
import React, { useMemo } from "react";
import { useAsync } from "react-use";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { getCorrectDate } from "@/utils/getCorrectDate";
import { initialOverviewTenDayChartFilters as filters } from "../../../utils/initialFilters";

interface AppendedFaDateSummerySubDetails extends DashboardSummerySubDetailsViewModel {
  axisDate: string;
  toolTipDate: string;
}

function appendFaDate(data?: DashboardSummeryDetailsViewModel): AppendedFaDateSummerySubDetails[] | undefined {
  if (!data) {
    return undefined;
  }

  const { daily: rawData } = data;
  const faData = rawData?.map((record: DashboardSummerySubDetailsViewModel) => {
    const axisDate = toJalali({
      // TODO: Wrong date format in backend (missing milliseconds), remove getCorrectDate after fix
      date: getCorrectDate(record.startDate),
      toFormat: "jD",
    }).string;
    const toolTipDate = toJalali({
      // TODO: Wrong date format in backend (missing milliseconds), remove getCorrectDate after fix
      date: getCorrectDate(record.startDate),
      toFormat: "jD jMMMM",
    }).string;

    return { ...record, axisDate, toolTipDate };
  });
  return faData;
}

interface CustomLegendProps {
  lines: AppLineType[];
}

const CustomLegend: React.FC<CustomLegendProps> = ({ lines }) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    {lines.map(({ color, key, label }, index) => (
      <Chart.LegendTag color={color} key={key} label={label} style={{ marginRight: `${index > 0 ? "1" : "0"}vw` }} />
    ))}
  </div>
);

const TenDayChart: React.FC = () => {
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();

  const { loading, value } = useAsync(() => dispatch(getSummary(filters)), []);
  const lineChartData = appendFaDate(value);

  const lines: AppLineType[] = useMemo(
    () => [
      {
        chartType: "bar",
        color: "#42526E",
        datatype: "amount",
        key: "amount",
        label: t("overview.tenDayChart.amount"),
      },
      {
        chartType: "line",
        color: "#52C41A",
        datatype: "number",
        hideY: true,
        key: "count",
        label: t("overview.tenDayChart.count"),
      },
    ],
    [t]
  );

  return (
    <Card.Raw>
      <Card.Raw.ColMeta
        header={
          <Card.Raw.RowMeta title={t("overview.lastTenDaysCount")} childrenJustify="flex-start">
            <CustomLegend lines={lines} />
          </Card.Raw.RowMeta>
        }
      >
        <Chart
          noDataPlaceholder={t("overview.tenDayChart.noDataPlaceholder")}
          lines={lines}
          data={lineChartData}
          xDataKey="axisDate"
          loading={loading}
        />
      </Card.Raw.ColMeta>
    </Card.Raw>
  );
};

export default TenDayChart;
